import { render, staticRenderFns } from "./SecurityOverviewTab.vue?vue&type=template&id=69789f32&"
import script from "./SecurityOverviewTab.vue?vue&type=script&lang=js&"
export * from "./SecurityOverviewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports